import { useDispatch, useSelector } from 'react-redux';
import '../../../themes/global.scss';
import '../../../themes/registration.scss';
import { useState } from 'react';
import { useLocation } from 'react-router';
import { BackButton } from '~/commonComponents';
import { editUserAccount } from '../../../actions';
import { Colors } from '../../../themes/colors';
import { ContainerLayout, ContentLayout, Title } from '../components';
import { DetailedView } from './DetailedView';
import { VerifyPhonePopup } from './VerifyPhonePopup';

export const GeneralOfficeInformation = () => {
  const location = useLocation();
  const isEditing = location?.state?.isEdit || false;
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const [contactNumber, setContactNumber] = useState();

  return (
    <>
      <ContainerLayout>
        <div style={{ position: 'absolute', left: 60, top: 140 }}>
          <BackButton color={Colors.white} url="/registration" />
        </div>
        <Title text="General Office Information" progress="step2" />
        <ContentLayout>
          <DetailedView
            isEditing={isEditing}
            submitBtnPressed={(data) => {
              dispatch(editUserAccount(data));
              setContactNumber(data.contact_number || user?.contact_number);
            }}
          />
        </ContentLayout>
      </ContainerLayout>
      <VerifyPhonePopup tel={contactNumber} />
    </>
  );
};
